import { reactive, watch, computed } from 'vue';
import { useRoute } from "vue-router";
import { ApiBannerCategoryIdEnum } from "@/enums/api/index"
import { getBannerV3 } from '@/api'
import { languageService } from "@/utils";

export const useTopNavBanner = () => {
    const route = useRoute();
    const { getLanguageId } = languageService;

    const bannerData = reactive({
        [ApiBannerCategoryIdEnum.TEXT_BANNER]: null,
        [ApiBannerCategoryIdEnum.CAMPAIGN]: null
    })

    const isShowBanner = computed(() => {
        const homePageName = ["home", "home-lang"];
        const productPageName = ["homeExplorer", "homeExplorer-lang"];
        return homePageName.includes(route.name) || (productPageName.includes(route.name) && route.params?.path?.length === 1)
    });

    const textBanner = computed(() => {
        return isShowBanner.value ? bannerData[ApiBannerCategoryIdEnum.TEXT_BANNER] : null;
    })

    const campaignBanner = computed(() => {
        return isShowBanner.value ? bannerData[ApiBannerCategoryIdEnum.CAMPAIGN] : null;
    })

    const getEventLabel = (bannerEventLabel) => {
        const eventLabelPrefixMapping = {
            'home': 'edu-licensing-course',
            'iclone': 'edu-licensing-course_ic',
            'character-creator': 'edu-licensing-course_cc',
            'cartoon-animator': 'edu-licensing-course_cta',
            'actorcore': 'edu-licensing-course_ac',
            'smart-gallery': 'edu-licensing-course_cm'
        };
        const currentRoute = ["home", "home-lang"].includes(route.name) ? `home` : `${route.params.path[0]}`;

        return eventLabelPrefixMapping[currentRoute] + `_${bannerEventLabel}`
    };


    const renderTextBanner = (bannerData) => {
        window.rlTextBanner.show(
            {
                messageHtml: `  
                            <style>
                                .text-banner-block { 
                                    margin-left: calc((3.75vw + 8px) * -1); 
                                    width: calc(100% + 2 * (3.75vw + 8px)) !important;
                                }

                                @media screen and (max-width: 768px) {
                                    .text-banner-block { padding-right: 0px;}
                                }
                                ${bannerData.BannerStyle}
                            </style>
                            <div class="text-banner-container">
                                <a  
                                    data-name='' 
                                    href='${bannerData.Url}' 
                                    style='text-decoration: underline;'
                                    target='${bannerData.Blank ? '_blank' : '_self'}'
                                >
                                    <div class="title" style="padding: 11px; text-align: center; font-size: 18px; font-weight: 300; min-height: 40px;"> 
                                        ${bannerData.Title}
                                    </div>
                                </a>
                            </div>
                            `,
                insertAfter:  "#text-banner",
                bannerClassName: bannerData.BannerClassName,
                eventName: getEventLabel(bannerData.EventLabel),
                displayFreq: 24,
                closeButton: {}
            }
        )
        
    };

    const fetchBannerData = async () => {
        const data = {
            [ApiBannerCategoryIdEnum.TEXT_BANNER]: null,
            [ApiBannerCategoryIdEnum.CAMPAIGN]: null
        };
        Object.assign(bannerData, data);

        try {
            const res = await getBannerV3({
                CategoryItemIds: [ApiBannerCategoryIdEnum.TEXT_BANNER,ApiBannerCategoryIdEnum.CAMPAIGN],
                Lang: getLanguageId()
            });
            res.forEach(banner => {
                bannerData[banner.CategoryItemId] = banner?.BannerList[0] ?? null
            });
        } 
        catch (error) {
            console.log(`getBannerV3 request error, Response = ${error?.status}, ReturnCode = ${error?.data?.apiStatus}`);
        }
    }

    fetchBannerData();

    watch(
        () => getLanguageId(),
        () => {
            if (isShowBanner.value) {
                fetchBannerData();
            }
        }
    )

    watch(
        textBanner,
        (val) => {
            $('.text-banner-block').remove();

            if (val) {
                renderTextBanner(val);
            }
        }
    )

    return {
        campaignBanner,
        getEventLabel
    }
}